export const OPEN_MODAL_EVENT = 'open'
export const CLOSE_MODAL_EVENT = 'close'
